import React, { useState, useEffect } from 'react';
import { chatHub } from '../../services/signalr';
import './MessageReactions.css';

const REACTIONS = {
  smile: ['😊', '😂', '🤔', '🤯', '😱', '😭', '😎','🥺'],
  others: ['👍', '👎', '👏', '🔥', '💯', '🎉','❤️', '👀']
};

const MessageReactions = ({ message, currentUserId, onUpdate }) => {
  const [showPicker, setShowPicker] = useState(false);
  const [pickerPosition, setPickerPosition] = useState({ x: 0, y: 0 });
  const [reactions, setReactions] = useState(message.reactions || []);

  // Синхронизируем реакции при обновлении сообщения
  useEffect(() => {
    setReactions(message.reactions || []);
  }, [message.reactions]);

  const handleReactionClick = async (messageId, emoji) => {
    const existing = reactions.find(r => r.emoji === emoji);
    const alreadyReacted = existing?.userIds?.includes(currentUserId);

    try {
      if (alreadyReacted) {
        await chatHub.removeReaction(messageId, emoji);
      } else {
        await chatHub.addReaction(messageId, emoji);
      }
      
      // Обновляем локальное состояние (если событие не пришло через SignalR)
      const updatedReactions = [...reactions];
      const reactionIndex = updatedReactions.findIndex(r => r.emoji === emoji);
      
      if (reactionIndex !== -1) {
        if (alreadyReacted) {
          // Удаляем текущего пользователя
          updatedReactions[reactionIndex].userIds = 
            updatedReactions[reactionIndex].userIds.filter(id => id !== currentUserId);
          if (updatedReactions[reactionIndex].userIds.length === 0) {
            updatedReactions.splice(reactionIndex, 1);
          }
        } else {
          // Добавляем текущего пользователя
          updatedReactions[reactionIndex].userIds.push(currentUserId);
        }
      } else if (!alreadyReacted) {
        // Создаём новую реакцию
        updatedReactions.push({
          emoji: emoji,
          userIds: [currentUserId]
        });
      }
      
      setReactions(updatedReactions);
      if (onUpdate) onUpdate({ ...message, reactions: updatedReactions });
      setShowPicker(false);
    } catch (error) {
      console.error('Ошибка управления реакцией:', error);
    }
  };

  const openPicker = (e, messageId) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    const pickerHeight = 120;
    const pickerWidth = 360;
    
    let x = rect.left;
    let y;
    
    if (rect.bottom + pickerHeight + 20 < windowHeight) {
      y = rect.bottom + 10;
    } else {
      y = rect.top - pickerHeight - 10;
    }
    
    if (x + pickerWidth + 20 > windowWidth) {
      x = windowWidth - pickerWidth - 20;
    }
    
    setPickerPosition({ x, y });
    setShowPicker(true);
  };

  // Обработчик клика вне панели
  useEffect(() => {
    const handleClickOutside = (e) => {
      const picker = document.querySelector('.reaction-picker');
      if (picker && !picker.contains(e.target)) {
        setShowPicker(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showPicker]);

  return (
    <>
      {/* Отображаем существующие реакции */}
      {reactions.length > 0 && (
        <div className="message-header-reactions">
          {reactions.map((reaction, index) => (
            <div 
              key={index} 
              className={`header-reaction ${reaction.userIds.includes(currentUserId) ? 'my-reaction' : ''}`}
              onClick={() => handleReactionClick(message.id, reaction.emoji)}
            >
              <span className="reaction-emoji">{reaction.emoji}</span>
              <span className="reaction-count">{reaction.userIds.length}</span>
            </div>
          ))}
        </div>
      )}

      {/* Кнопка открытия панели реакций (только для своих сообщений) */}
        <button 
            className="reaction-trigger"
            onClick={(e) => openPicker(e, message.id)}
        >
            <span className="reaction-trigger-icon">🙂</span>
            <span className="reaction-trigger-plus">+</span>
        </button>

      {/* Панель выбора реакций */}
      {showPicker && (
        <div 
          className="reaction-picker"
          style={{ 
            position: 'fixed',
            left: pickerPosition.x,
            top: pickerPosition.y,
            zIndex: 1000
          }}
        >
          {Object.entries(REACTIONS).map(([group, emojis]) => (
            <div key={group} className="reaction-group">
              <div className="reaction-grid">
                {emojis.map(emoji => (
                  <span 
                    key={emoji} 
                    className="reaction-option"
                    onClick={() => handleReactionClick(message.id, emoji)}
                  >
                    {emoji}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default MessageReactions;